import React from 'react';
/**
 * SlideOver — Backward Compatibility Re-export
 *
 * Canonical source moved to src/portals/shared/SlideOver.tsx (CP-1 fix).
 * This file re-exports for backward compatibility with admin portal consumers.
 */
export { SlideOver } from '../../shared/SlideOver';